import { render } from "./Key3.vue?vue&type=template&id=6860518a"
import script from "./Key3.vue?vue&type=script&lang=ts"
export * from "./Key3.vue?vue&type=script&lang=ts"
script.render = render

export default script